<template>
  <div v-if="rates && !reviewsError" id="customer-reviews">
    <ReviewsBlock
      :ai-summary="undefined"
      :ai-summary-pending="false"
      :next-reviews-cursor="reviews?.nextCursor"
      :pending-summary="ratingSummaryPending"
      :previous-reviews-cursor="reviews?.previousCursor"
      :product-id="undefined"
      :product-title="title"
      :rating="rates"
      :rating-summary
      :reviews="reviews?.results || []"
      :reviews-pending="pendingReviews"
    />
  </div>
</template>

<script setup lang="ts">
import { watch } from 'vue'

import type { Rating } from '@backmarket/http-api/src/api-specs-reviews/types/rating'
import { useLogger } from '@backmarket/nuxt-module-logger/useLogger'

import ReviewsBlock from '~/scopes/reviews/reviews-display/components/ReviewsBlock/ReviewsBlock.vue'
import { useRatingDetailsSummary } from '~/scopes/reviews/reviews-display/composables/useRatingDetailsSummary'

import { useProductListReviews } from '../../composables/useProductListReviews'

const logger = useLogger()

const props = defineProps<{
  title: string
  id: string
  slug: string
  rates: Rating | null
}>()

const {
  data: reviews,
  pending: pendingReviews,
  error: reviewsError,
} = useProductListReviews(props.id)

watch(reviewsError, () => {
  if (!reviewsError.value) return

  logger.error('[PLP Reviews] Failed to fetch', {
    error: reviewsError.value,
    owners: ['bot-squad-content-front'],
  })
})

const { data: ratingSummary, pending: ratingSummaryPending } =
  useRatingDetailsSummary()
</script>
